import React, { Component } from "react";
import PropTypes from "prop-types";
import { authHttpFactory } from "../../apiConfig";
import accessErrorFactory from "./accessErrorFactory";
import SigningDocuments from "./signingDocuments";

const propTypes = {
  signingId: PropTypes.string.isRequired,
  setLoading: PropTypes.func.isRequired,
  blockPage: PropTypes.func.isRequired,
  showAlert: PropTypes.func.isRequired,
};

class OtpSignature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: null,
    };

    this.http = authHttpFactory(props.signingId);
  }

  componentDidMount() {
    this.getDocuments(this.props.signingId);
  }

  getDocuments(signingId) {
    this.props.setLoading(true);

    this.http.get(`/signing/${signingId}/documents`).then(
      (response) => {
        this.props.setLoading(false);

        if (response.status === 200) {
          this.setState({
            documents: response.data,
          });
        }
      },
      (err) => {
        this.props.setLoading(false);

        const error = accessErrorFactory(err);
        if (!error) {
          return;
        }

        this.props.showAlert(error.message, "error");
        if (error.blocking) {
          this.props.blockPage();
        }
      }
    );
  }

  render() {
    if (!this.state.documents) {
      return <div />;
    }

    return (
      <SigningDocuments
        signingId={this.props.signingId}
        items={this.state.documents}
      />
    );
  }
}

OtpSignature.propTypes = propTypes;
export default OtpSignature;
